/* src/app/core/modules/shared/components/timed-button/timed-button.component.scss */
/*# sourceMappingURL=/avvera/dev/timed-button.component.css.map */
